var map = {
	"./4-in-a-raw.ico": 952,
	"./images/avatar1.png": 755,
	"./images/avatar10.png": 203,
	"./images/avatar11.png": 994,
	"./images/avatar12.png": 329,
	"./images/avatar13.png": 712,
	"./images/avatar14.png": 879,
	"./images/avatar15.png": 862,
	"./images/avatar16.png": 661,
	"./images/avatar17.png": 596,
	"./images/avatar18.png": 195,
	"./images/avatar19.png": 66,
	"./images/avatar2.png": 192,
	"./images/avatar20.png": 218,
	"./images/avatar21.png": 875,
	"./images/avatar22.png": 120,
	"./images/avatar3.png": 393,
	"./images/avatar4.png": 422,
	"./images/avatar5.png": 223,
	"./images/avatar6.png": 948,
	"./images/avatar7.png": 189,
	"./images/avatar8.png": 306,
	"./images/avatar9.png": 139,
	"./media/drop-coin.mp3": 932,
	"./media/game-music-loop-.mp3": 381,
	"./media/game-over-01.mp3": 458,
	"./media/game-over-02.mp3": 461,
	"./media/my-turn-01.mp3": 379,
	"./media/my-turn-02.mp3": 4,
	"./media/select-column-button.mp3": 185,
	"./media/win-game-01.mp3": 740,
	"./media/win-game-02.mp3": 531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;